export const isTodayAfter2025 = () => {
    const lastDayIn2025 = new Date("2025-12-31"); // Convert lastDay in 2025 to a Date object
    const today = new Date(); // Get today's date

    // Set the time to 0:00:00.000 for an accurate comparison
    lastDayIn2025.setHours(23, 59, 59, 59);
    today.setHours(23, 59, 59, 59);

    return today > lastDayIn2025;
};
